export default {
  auto: 'Auto',
  signals: 'Signale',
  axes: 'Achsen',
  axesHeader: {
    displayName: 'Achsenbeschriftung',
    chartScaleType: 'Achsentyp',
    position: 'Achsenposition',
    limitMin: 'Untere Grenze',
    limitMax: 'Obere Grenze',
    defaultUnitOfMeasure: 'Maßeinheit',
    signalCount: 'Anzahl der Signale',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Achse löschen?',
    message: 'Die {count} Signale dieser Achse werden ebenfalls aus dem Diagramm entfernt.',
  },
};
